import { legacy } from '@/shared/api/client';
import type { OwnerDashboardResponse, OwnerStoreCard } from '@/shared/types/owner';

const PUBLIC_API = import.meta.env.VITE_PUBLIC_API_URL as string;

/** Owner legado que nunca vê o botão Criar Cartão (paridade com owner.ejs). */
export const LEGACY_CREATE_CARD_EXCLUDED_USER_ID = '66b4df54eb94fe45f46f9072';

/** Front do convite (legado `front_path` em produção). Não usar `fixe.club`. */
const GIFT_CARD_INVITE_ORIGIN = 'https://front.epossible.com.br';

/** Mesma regra do legado: giftcard ativo e usuário não excluído. */
export function canCreateGiftcard(store: Pick<OwnerStoreCard, 'hasGiftcard'>, userId: string): boolean {
  return Boolean(store.hasGiftcard) && userId !== LEGACY_CREATE_CARD_EXCLUDED_USER_ID;
}

export function giftCardInviteUrl(passbookId: string): string {
  return `${GIFT_CARD_INVITE_ORIGIN}/invite/${passbookId}`;
}

export async function fetchOwnerDashboard(userId: string): Promise<OwnerDashboardResponse> {
  return legacy.post<OwnerDashboardResponse>('/owner/', { id: userId });
}

/** Normaliza a resposta aninhada legada em cards planos. */
export function parseOwnerStores(data: OwnerDashboardResponse): OwnerStoreCard[] {
  const raw = data.passbooks ?? [];
  const cards: OwnerStoreCard[] = [];

  for (const entry of raw) {
    const client = Array.isArray(entry) ? (entry as unknown[])[0] : entry;
    if (!client || typeof client !== 'object') continue;

    const doc = client as {
      name?: string;
      passbooks?: Array<{ _id: string; backgroundColor?: string; hasGiftcard?: boolean }>;
    };

    const passbook = doc.passbooks?.[0];
    if (!passbook?._id) continue;

    cards.push({
      clientName: doc.name ?? 'Loja',
      passbookId: passbook._id,
      backgroundColor: passbook.backgroundColor,
      hasGiftcard: passbook.hasGiftcard,
    });
  }

  return cards.sort((a, b) => a.clientName.localeCompare(b.clientName, 'pt-BR'));
}

export function passbookLogoUrl(passbookId: string): string {
  return `${PUBLIC_API}/${passbookId}/logo.png`;
}

export async function requestOwnerExport(kind: 'data' | 'users', email: string) {
  const path = kind === 'users' ? `/owner/export/users/${encodeURIComponent(email)}` : `/owner/export/${encodeURIComponent(email)}`;
  await legacy.get(path);
}
